import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { DocumentTypeEnum } from "../document/contracts/document-type.contract";
import { Document } from "../document/document.model";
import { FORM_GROUP_STATUS } from "./contract/form-group-contracts";
import { FormTemplateGroup } from "./form-template-group.model";
import { FormTemplate } from "./form-template.model";

export class FormGroup extends BaseModel {
  id: number;
  name: string;
  internalName: string;
  description: string;
  @Type(() => Boolean)
  isMSF: boolean;
  @Type(() => Boolean)
  isDraft: boolean;
  @Type(() => Boolean)
  isArchived: boolean;
  @Type(() => Boolean)
  isInReview: boolean;
  @Type(() => Boolean)
  isInChangesRequired: boolean;
  @Type(() => Boolean)
  isApproved: boolean;
  @Type(() => Boolean)
  isPublished: boolean;
  @Type(() => FormTemplateGroup)
  formTemplateGroups: FormTemplateGroup[];
  @Type(() => Document)
  documents: Document[];
  formGroupInstancesCount = 0;
  responseCount = 0;

  public getFormTemplates(): FormTemplate[] {
    if (this.formTemplateGroups && this.formTemplateGroups.length > 0) {
      return this.formTemplateGroups.map(
        (formTemplateGroup: FormTemplateGroup) => formTemplateGroup.formTemplate
      );
    } else {
      return [];
    }
  }

  public getFormDocuments(documentTypes: DocumentTypeEnum[]): Document[] {
    if (this.documents && this.documents.length > 0) {
      return this.documents.filter((document: Document) =>
        documentTypes.includes(document.documentType.id)
      );
    } else {
      return [];
    }
  }

  /**
   * @description works out the sum of all minimum number of responses required for all form templates in this form group
   * @returns
   */
  get minResponsesForFullAcrossAllTemplates(): number {
    return this.formTemplateGroups.reduce((sum, formTemplateGroup) => {
      return sum + formTemplateGroup.formTemplate.minResponsesForFull;
    }, 0);
  }

  /**
   * @description works out the sum of all minimum number of responses required for all form templates in this form group
   * @returns
   */
  get minResponsesForAbrvFullAcrossAllTemplates(): number {
    return this.formTemplateGroups.reduce((sum, formTemplateGroup) => {
      return sum + formTemplateGroup.formTemplate.minResponsesForAbrv;
    }, 0);
  }

  get status(): string {
    if (this.isArchived) {
      return FORM_GROUP_STATUS.Archived;
    } else if (this.isDraft) {
      return FORM_GROUP_STATUS.Draft;
    } else if (this.isInReview) {
      return FORM_GROUP_STATUS.InReview;
    } else if (this.isInChangesRequired) {
      return FORM_GROUP_STATUS.ChangesRequired;
    } else if (this.isApproved) {
      return FORM_GROUP_STATUS.Approved;
    } else if (this.isPublished) {
      return FORM_GROUP_STATUS.Published;
    } else {
      return FORM_GROUP_STATUS.Unknown;
    }
  }

  get type(): string {
    return this.isMSF ? "MSF" : "No MSF";
  }

  get formTemplatesCount(): number {
    return this.formTemplateGroups ? this.formTemplateGroups.length : 0;
  }
}
